module.exports = "../static/images/53cb17.png";